import { buildPermission } from "portal/utils/auth";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { useAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";

export const adminCarbonCropsReadStatement = buildPermission(
  PermissionAction.read,
  PermissionResource.carbon_crops_management,
  PermissionDomain.all
);

export const adminCarbonCropsUpdateStatement = buildPermission(
  PermissionAction.update,
  PermissionResource.carbon_crops_management,
  PermissionDomain.all
);

export const useCanSeeAdminCarbonCrops = (): boolean =>
  useAuthorizationRequired(adminCarbonCropsReadStatement);

export const useCanUpdateAdminCarbonCrops = (): boolean =>
  useAuthorizationRequired(adminCarbonCropsUpdateStatement);
